export enum productRoutesPaths {
  root = '/products',
  premixes = '/products/premixes',
  recipes = '/products/recipes',
  ingredients = '/products/ingredients',
}
